import { lastItem } from 'utils/array';
import { type NeedsAttentionCard, type QueueIssue } from '../data/queueTypes';
import { type IssueQueueSection } from '../useMissionControlStore';

/**
 * Identifies a queue row. Rows are keyed per section, since the same Issue can
 * appear in more than one.
 */
export type QueueRowKey =
    | `needs-attention:${string}`
    | `follow-up:${string}`
    | `closeout:${string}`;

/** A queue row, with the name messages about it refer to it by. */
export type QueueRow = Readonly<{ key: QueueRowKey; label: string }>;

export function getNeedsAttentionRowKey(assemblyId: string): QueueRowKey {
    return `needs-attention:${assemblyId}`;
}

export function getIssueQueueRowKey(
    section: IssueQueueSection,
    issueId: string,
): QueueRowKey {
    switch (section) {
        case 'followUp':
            return `follow-up:${issueId}`;
        case 'closeout':
            return `closeout:${issueId}`;
    }
}

export function getNeedsAttentionRow(card: NeedsAttentionCard): QueueRow {
    return {
        key: getNeedsAttentionRowKey(card.AssemblyId),
        label: getAssemblyName(card),
    };
}

export function getIssueQueueRow(
    section: IssueQueueSection,
    issue: QueueIssue,
): QueueRow {
    return {
        key: getIssueQueueRowKey(section, issue.Id),
        label: `Issue #${issue.FormattedIssueNumber}`,
    };
}

/** The name of the card's Assembly, the last of its hierarchy. */
export function getAssemblyName(card: NeedsAttentionCard): string {
    const assembly = lastItem(card.Hierarchy);
    if (!assembly) {
        throw new Error(`Assembly card ${card.AssemblyId} has an empty hierarchy`);
    }
    return assembly.HierarchyName;
}
